import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=ebe90d7e&"
import script from "./Basket.vue?vue&type=script&lang=js&"
export * from "./Basket.vue?vue&type=script&lang=js&"
import style0 from "./Basket.vue?vue&type=style&index=0&id=ebe90d7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports